import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { MenuManageComponent } from "./menu.component";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faServer, faDisplay, faUser, faCircleInfo , faAddressCard, faPowerOff, faChartSimple, faCircleUser, faChartLine} from "@fortawesome/pro-regular-svg-icons";


@NgModule({
    imports: [
      CommonModule,
      NgbModule,
      RouterModule,
      FontAwesomeModule,
    ],
  
    exports: [MenuManageComponent],
    declarations: [MenuManageComponent]
  })
  export class MenuManageModule {
    constructor(library: FaIconLibrary) {
      library.addIcons( faServer, faDisplay, faUser,  faCircleInfo , faAddressCard, faPowerOff, faChartSimple, faCircleUser, faChartLine );
    }
   }
  